import { Button } from "@mui/material";
import { useState } from "react";
import { postFn, putFn } from "../../../Services/sharedGeneralFn";
import { useMutation, useQueryClient } from "react-query";
import { API_URLS } from "../../../config/apiUrls";
import { toast } from "react-toastify";

const AddImageState = ({
  setState,
  variantId,
  editImageId,
  setEditImageId,
}) => {
  const [image, setImage] = useState([]);
  const client = useQueryClient();

  const handleClose = () => {
    setEditImageId(null);
    setState((prev) => prev - 1);
  };

  const { mutate: mutation } = useMutation(
    (args) => (editImageId ? putFn(...args) : postFn(...args)),
    {
      onSuccess: (res) => {
        if (res.data.response_code === 200) {
          toast.success(res.data.message);
          client.refetchQueries("multipleImageData");
          handleClose();
        } else {
          toast.error(res.data.message);
        }
      },
    }
  );

  const handleAddFn = () => {
    if (image) {
      const reqBody = new FormData();
      if (editImageId) {
        reqBody.append("product_variant_image_id", editImageId);
      }
      reqBody.append("product_variant_value", variantId);
      reqBody.append("variant_image", image);
      const args = [reqBody, API_URLS.multipleImageApi];
      mutation(args);
      console.log("AA", image);
    } else {
      toast.warn("Add an image first");
    }
  };

  return (
    <div>
      <div className="flex flex-row items-center gap-4">
        <div className="font-semibold">Image: </div>
        <input
          size="small"
          multiple
          type="file"
          onChange={(event) => setImage(event.target.files[0])}
          className="!w-[100%] !mt-1 border rounded border-gray-300 p-1"
          name="image"
        />
      </div>

      <div className="flex flex-row justify-center gap-4 mt-4">
        <Button
          onClick={handleClose}
          variant="contained"
          color="warning"
          className="flex flex-grow"
        >
          BACK
        </Button>
        <Button
          variant="contained"
          type="submit"
          color="success"
          className="flex flex-grow"
          onClick={handleAddFn}
        >
          {editImageId ? "UPDATE" : "ADD"}
        </Button>
      </div>
    </div>
  );
};

export default AddImageState;
